import { CommonModule, NgFor, NgIf } from '@angular/common';
import { Component, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormsModule, NgForm, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router, RouterLink } from '@angular/router';
import { fuseAnimations } from '@fuse/animations';
import { FuseAlertComponent, FuseAlertType } from '@fuse/components/alert';
import { FuseConfigService } from '@fuse/services/config';
import { AuthService } from 'app/core/auth/auth.service';
import { FuseCardComponent } from '@fuse/components/card';

import { FuseHorizontalNavigationComponent, FuseNavigationItem, FuseVerticalNavigationComponent } from '@fuse/components/navigation';
import Swal from 'sweetalert2';
import { NavigationService } from 'app/core/navigation/navigation.service';
import { NavigationComponent } from 'app/modules/navigation/navigation.component';
import { PaymentService } from 'app/services/payment.service';
import { SubscriptionService } from 'app/services/subscription.service';
import { lastValueFrom } from 'rxjs';
import { JourneyService } from 'app/services/journey.service';
import { SharedMethods } from 'app/shared/shared-methods';
import { MobileNavigation } from 'app/modules/mobile-navigation/navigation.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
@Component({
  standalone: true,
  selector: 'app-buy-subscription',
  templateUrl: './buy-subscription.component.html',
  styleUrls: ['./buy-subscription.component.scss'],
  encapsulation: ViewEncapsulation.None,
  animations: fuseAnimations,
  imports: [RouterLink, FuseCardComponent, NavigationComponent, NgFor, NgxSkeletonLoaderModule, MobileNavigation, FuseAlertComponent, FuseHorizontalNavigationComponent, FuseVerticalNavigationComponent, NgIf, FormsModule, ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatButtonModule, MatIconModule, MatCheckboxModule, MatProgressSpinnerModule, CommonModule],
})
export class BuySubscriptionComponent implements OnInit {
  @ViewChild('fuseCard') fuseCard!: FuseCardComponent;
  @ViewChild('subscriptionNgForm') subscriptionNgForm: NgForm;
  mainNavigation: FuseNavigationItem[];
  alert: { type: FuseAlertType; message: string } = {
    type: 'success',
    message: '',
  };
  public subscriptionForm: UntypedFormGroup;
  public showAlert: boolean = false;
  public selectedButton: string = 'annually';
  public price: number;
  public subPrice: string;
  public subDetails: any;
  public showSpinner: boolean;
  public subscriptionGridList: any;
  public subscriptionDetails: any;
  public subGrid: any;
  public loading: boolean = false;
  public subInfo: SafeHtml;
  public paymentText: string;
  public priceString: string;
  public monthlySubPrice: string;
  public annualSubPrice: string;
  public monthlySubName: string;
  public annualSubName: string;
  public trialSubName: string;
  public onceOffSubName: string;
  public onceOffSubPrice: string;
  /**
   * Constructor
   */

  constructor(
    private _authService: AuthService,
    private _formBuilder: UntypedFormBuilder,
    private _fuseConfig: FuseConfigService,
    public router: Router,
    public paymentService: PaymentService,
    private _subscriptionService: SubscriptionService,
    private _journeyService: JourneyService,
    private _navigationService: NavigationService,
    public sharedMethods: SharedMethods,
    private sanitizer: DomSanitizer
  ) {
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------
  /**
   * On init
   */
  async ngOnInit(): Promise<void> {
    // Create the form
    this.loading = true;
    this.subGrid = await this.subscriptionGrid();

    if (this.subGrid) {
      //   this.subscriptionForm = this._formBuilder.group({
      //     email: ['', [Validators.required, Validators.email]],
      //     password: ['', Validators.required],
      //     userType: [this._fuseConfig.global.settings.userType],
      //     phoneNumber: [''],
      //     name: [''],
      //     surname: [''],
      //     rememberMe: [''],
      // });
      if (sessionStorage.getItem("tryForFree")) {
        await this.selectSub('trial');
      } else {
        await this.selectSub('annually');
      }
      await this.getSubName();
    }
  }



  public async selectSub(buttonType: string): Promise<void> {
    this.selectedButton = buttonType;
    this.subscriptionDetails = await this.subscriptionGridList.data.records.find(element => this.selectedButton === element?.row?.recurrence?.toLowerCase());
    this.paymentText = "YOU WILL BE PAYING";
    switch (this.selectedButton) {
      case 'annually':
        this.price = this.subscriptionDetails?.row?.price;
        // this.priceString = this.price
        this.subPrice = `R${(this.price / 12).toFixed(2)}/month (Best Value)`;
        this.subInfo = this.transformSubDetails(this.subscriptionDetails?.row?.full_description, this.price);

        this.sharedMethods.trackEvent('click', {
          event_category: 'subscription_selection',
          event_label: 'annual_subscription',
        });

        break;
      case 'monthly':

        this.price = this.subscriptionDetails?.row.price;
        this.priceString = `R${this.price}`
        this.subPrice = `R${(this.price)}/month`;
        this.subInfo = this.transformSubDetails(this.subscriptionDetails?.row?.full_description, this.price);

        this.sharedMethods.trackEvent('click', {
          event_category: 'subscription_selection',
          event_label: 'monthly_subscription'
        });
        break;
      case 'trial':
        this.paymentText = "NO CREDIT CARD REQUIRED";
        this.price = 0
        this.priceString = `21 days for free`
        this.subPrice = "Risk-free - no credit card required"
        this.subInfo = this.transformSubDetails(this.subscriptionDetails?.row?.full_description, this.price)

        this.sharedMethods.trackEvent('click', {
          event_category: 'subscription_selection',
          event_label: 'trial_subscription'
        });
        break;
      case 'once-off':
        this.price = this.subscriptionDetails?.row?.price;
        this.priceString = `R${this.price}`
        const monthsAmount = this.subscriptionDetails?.row?.months_amount || 36;
        this.subPrice = `One-time payment for ${monthsAmount} months`;
        this.subInfo = this.transformSubDetails(this.subscriptionDetails?.row?.full_description, this.price);
        this.sharedMethods.trackEvent('click', {
          event_category: 'subscription_selection',
          event_label: 'once_off_subscription'
        });
        break;
      default:
        break;
    }
    this.loading = false;
  }



  public async getSubName() {
    this.subscriptionGridList?.data?.records.forEach(element => {
      switch (element?.row?.recurrence) {
        case "Monthly":
          this.monthlySubName = element?.row?.name;
          this.monthlySubPrice = element?.row?.price;
          break;
        case "Annually":
          this.annualSubName = element?.row?.name;
          this.annualSubPrice = element?.row?.price;
          break;
        case "Trial":
          this.trialSubName = element?.row?.name;
          break;
        case "Once-Off":
          this.onceOffSubName = element?.row?.name;
          this.onceOffSubPrice = element?.row?.price;
          break;
        default:
          break;
      }
    });
  }

  async buySubscription() {
    this.showSpinner = true;
    switch (this.selectedButton) {
      case "monthly":
        this.sharedMethods.trackEvent('select_subscription_monthly', {
          subscription_type: this.selectedButton,
          event_name: 'select_subscription'
        });
        break;
      case "annually":
        this.sharedMethods.trackEvent('select_subscription_annually', {
          subscription_type: this.selectedButton,
          event_name: 'select_subscription'
        });
        break;
      case "trial":
        this.sharedMethods.trackEvent('select_subscription_trial', {
          subscription_type: this.selectedButton,
          event_name: 'select_subscription'
        });
        break;
      case "once-off":
        this.sharedMethods.trackEvent('select_subscription_once_off', {
          subscription_type: this.selectedButton,
          event_name: 'select_subscription'
        });
        break;
    }

    sessionStorage.setItem("package", this.selectedButton);
    localStorage.setItem("selectedPackage", this.selectedButton);
    this.router.navigate(['/sign-up']).then(() => {
      this.showSpinner = false;
    });
  }

  home() {
    this.router.navigate(['/sign-in']);
  }


  private async subscriptionGrid() {
    this.subscriptionGridList = await lastValueFrom(this._subscriptionService.gridSubscription()).catch(() => {
      return null;
    });
    if (this.subscriptionGridList) {
      return true;
    }
  }

  private transformSubDetails(text: string, price: number) {

    if (text && price) {
      let replacedText = text?.replace("{{PRICE}}", price?.toString());
      return this.sanitizer.bypassSecurityTrustHtml(replacedText)
    } else
      return "";

  }
}
